export default __webpack_public_path__ + "static/media/arrow-3.efc3debf.efc3debf.png";